import React, { Fragment, useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import {  useParams } from 'react-router-dom'
import Services from '../../api/Services';
import ServiceSidebar from './sidebar'
// import simg1 from '../../images/service-single/img-1.jpg'
// import simg2 from '../../images/service-single/img-2.jpg'
import Footer from '../../components/footer/Footer';
// import CursorMaus from '../../components/CursorMaus/CursorMaus';
import Logo from '../../images/logo-2.svg'
import Phone from '../../images/telephone.svg'
import LenisSmoothScroll from '../../components/lenissmoothscroll/LenisSmoothScroll';
/*import Accordion from './accordion';*/





const ServiceSinglePage = (props) => {
    const { slug } = useParams()

    const serviceDetails = Services.find(item => item.slug === slug)

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [slug]);

    return (
        <Fragment>
            <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
            <PageTitle pageTitle={serviceDetails.title} pagesub={'Service'} />
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8  col-md-12">
                            <div className="service-single-wrap">
                                <div className="service-single-content">
                                    <img src={serviceDetails.sSImg} alt="" />
                                    <div className="service-single-content-des">
                                        <h2 style={{ marginBottom: 0 }}>{serviceDetails.title}</h2>
                                        <div
                                            className="service-single-content-des" style={{textAlign:'justify'}}

                                            dangerouslySetInnerHTML={{ __html: serviceDetails.content }}
                                        />

                                        {/*<div className="service-single-sub-img">
                                            <ul>
                                                <li><img src={simg1} alt="" /></li>
                                                <li><img src={simg2} alt="" /></li>
                                            </ul>

                                        </div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ServiceSidebar />
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
            < LenisSmoothScroll />
            {/* <CursorMaus /> */}
        </Fragment>
    )
};
export default ServiceSinglePage;


